import { useState } from 'react';
import { Eye } from 'react-feather';
import TablaServidor from '../../components/tabla/TablaServidor';
import ModalHeaderBody from '../../layouts/modals/ModalHeaderBody';
import BodyRemesa from './BodyRemesa';
import { COLUMNAS_REMESAS, TABLA_REMESAS } from './columnasRemesas';

const ListadoEmails = () => {
  const [dataDetail, setDataDetail] = useState(null);
  const [openRemesaDetail, setOpenRemesaDetail] = useState(false);

  // El detalle pide los envíos a la BD de la sede de la remesa.
  const verDetalle = (fila) => {
    setDataDetail({ ...fila, centro: fila.empresaId });
    setOpenRemesaDetail(true);
  };

  return (
    <>
      <TablaServidor
        tablaKey={TABLA_REMESAS}
        columnas={COLUMNAS_REMESAS}
        ruta="listado-remesas"
        archivo="remesas-email"
        nombreEntidad="remesas"
        placeholder="Buscar por asunto, usuario o ID…"
        claveFila={(f) => `${f.empresaId}-${f.IdRemesa}`}
        onFilaClick={verDetalle}
        renderAcciones={(f) => (
          <button
            type="button"
            className="tbl-icono"
            aria-label="Ver detalle"
            title="Ver detalle"
            onClick={(e) => {
              e.stopPropagation();
              verDetalle(f);
            }}
          >
            <Eye size={15} />
          </button>
        )}
        tituloTarjeta={(f) => f.Descripcion || `#${f.IdRemesa}`}
      />

      {openRemesaDetail && (
        <ModalHeaderBody
          open={openRemesaDetail}
          setOpen={setOpenRemesaDetail}
          title={`Detalle de la remesa ${dataDetail.IdRemesa}`}
          size="xl"
        >
          <BodyRemesa remesa={dataDetail} />
        </ModalHeaderBody>
      )}
    </>
  );
};

export default ListadoEmails;
